import { FunctionComponent, useRef } from 'react'
import Paging from 'Features/Paging/paging'
import { convertDate, convertDateAndTime } from 'Frontend/scripts/convertDates'
import { useTranslation } from 'react-i18next'
import { useSearchContext } from './forumQAndAContext'

const ForumQandAList: FunctionComponent = () => {
  const { searchHits, state, setPage } = useSearchContext()
  const forumListRef = useRef<HTMLDivElement | null>(null)
  const { t } = useTranslation()

  return (
    <div className="forums" ref={forumListRef}>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h2>{t('search-result')}</h2>
        <a className="btn btn-secondary text-white" href={`${window.location.href.split('?')[0]}/CreateNewThread`}>
          {t('new-question')}
        </a>
      </div>
      <p className="mb-4">
        {t('your-search-no-of-hits', { searchWord: state.query, noOfHits: searchHits?.totalItems })}
      </p>

      <div className="d-flex flex-column gap-2">
        {searchHits?.items?.map((item) => (
          <div className="livstecknet__listing-content-row" key={`result-${item.id}`}>
            <div>
              <h3 className="livstecknet__listing-content-row-link">
                <a href={item.url} className="stretched-link">
                  {item.title}
                </a>
              </h3>
              {item.tags && item.tags?.length > 0 && (
                <div className="d-flex flex-wrap gap-2 mb-1">
                  {item.tags.map((tag) => (
                    <div
                      className="bg-secondary text-white rounded-pill forum-thread__tags text-capitalize"
                      key={`tag-${tag.tagId}`}
                    >
                      {tag.name}
                    </div>
                  ))}
                </div>
              )}
              <p className="livstecknet__listing-content-row-text">
                {item.createdByUser != null && (
                  <>
                    {t('created-by')} {item.createdByUser?.firstname} {item.createdByUser?.lastname},{' '}
                  </>
                )}
                {item.createdByUser === null && t('created')} {convertDate(item.created)}
              </p>
              <div className="d-flex gap-3">
                <div>
                  <span className="fw-bold">{t('number-of-answers')}:</span>{' '}
                  <span className="fa fa-comment-o me-1"></span>
                  {item.numberOfResponses}
                </div>
                {item.lastReplyDateTime != null && (
                  <div>
                    <span className="fw-bold">{t('latest-answers')}:</span> {convertDateAndTime(item.lastReplyDateTime)}
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
        {(searchHits?.totalPages as number) > 1 && (
          <Paging
            noOfPages={searchHits?.totalPages as number}
            activePage={state.page as number}
            callback={(activePage) => {
              setPage(activePage)
              forumListRef?.current && forumListRef.current.scrollIntoView()
            }}
          />
        )}
      </div>
    </div>
  )
}
export default ForumQandAList
